<!--<template>
    <div>-->

        <!--<div class="container-logoFisimed flex-row-center">
            <img id="logoFisimed" src ="/images/logoFisi.png" alt="logo FISI"/>
        </div>-->
        <!--<ul class="container-links">
            <li>
                <router-link tag="div" class="link" to="/">Logiciels</router-link>
                <ul class="container-sub-link">
                    <li><router-link class="sub-link" to="/fisimed">Fisimed</router-link></li>
                    <li><router-link class="sub-link" to="/altyse">Altyse</router-link></li>
                </ul>
            </li>
            <li>
                <router-link class="sub-link" to="/fisimed">Deconnexion</router-link>
            </li>
        </ul>-->

        <!--<div id="container-navBar">
            <div class="container-logo-and-burger">
                <span @click="reload()" class="container-logoFisimed"> <img id="logoFisimed" src="../images/logoFisi.png" alt="logo FISI" /></span>
                <div class="container-burger-menu" @click="showMenu()">
                    <svg width="50px" height="50px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M4 18L20 18" stroke="#000000" stroke-width="2" stroke-linecap="round" />
                        <path d="M4 12L20 12" stroke="#000000" stroke-width="2" stroke-linecap="round" />
                        <path d="M4 6L20 6" stroke="#000000" stroke-width="2" stroke-linecap="round" />
                    </svg>
                </div>
            </div>
            <div id="container-links">
                <span class="container-sub-link"><a @click="lancerFisimedClients" class="sub-link">Fisimed</a></span>
                <span class="container-sub-link"><a @click="lancerAltyseClients" class="sub-link">Altyse</a></span>
                <span class="container-sub-link"><a @click="lancerFlic32" class="sub-link">Flic32</a></span>
                <span class="container-sub-link"><a @click="lancerTransCAM" class="sub-link">TransCAM</a></span>
                <span v-if="connexionValeur" class="container-sub-link"><a @click="deconnexion" class="sub-link">Deconnexion</a></span>
            </div>
        </div>
    </div>
</template>-->
<template>
    <!-- Bouton flottant pour afficher/masquer le menu sur telephone -->
    <v-btn v-if="estMobile"
           icon
           size="small"
           color="#395293"
           class="navbar-toggle-btn"
           @click="drawer = !drawer">
        <v-icon>{{ drawer ? 'mdi-chevron-left' : 'mdi-chevron-right' }}</v-icon>
    </v-btn>

    <!-- Navigation Drawer : permanent en bureau, masquable sur telephone -->
    <v-navigation-drawer v-model="drawer"
                         app
                         :permanent="!estMobile"
                         :temporary="estMobile"
                         :expand-on-hover="!estMobile"
                         class="bg-grey-lighten-3">
        <!-- Logo -->
        <h1 class="text-h4 font-weight-bold my-12 text-center" style="color: #395293;">TransCAM</h1>

        <div class="d-flex flex-column mb-3 mx-8" style="gap: 10px;">
            <v-btn class="mb-3" color="#119393" v-on:click="lancerVitale">Lire Carte Vitale</v-btn>
        </div>

        <div class="d-flex flex-column mb-6 mx-8" style="gap: 10px;">
            <v-btn class="mb-3" color="#119393" v-on:click="lireCPS">Lire CPS</v-btn>
        </div>

        <!-- Acces rapide a la nouvelle feuille (NewFSE), encore non reliee -->
        <div class="d-flex flex-column mb-6 mx-8" style="gap: 10px;">
            <v-btn class="mb-3" color="#FF8C00" v-on:click="lancerNewFSE">NewFSE (apercu)</v-btn>
        </div>

        <v-list class="mb-20" dense>
            <v-list-item v-for="(item, index) in items"
                         :key="index"
                         link>
                <template v-slot:default>
                    <div class="d-flex align-center mx-4 my-3"
                         @click="callItemMethod(item.method)">
                        <v-icon class="ml-1 mr-2" size="35">{{ item.icon }}</v-icon>
                        <v-list-item-title class="font-weight-bold">
                            {{ item.title }}
                        </v-list-item-title>
                    </div>
                </template>
            </v-list-item>
        </v-list>

        <div style="height: 85px"></div>

        <v-list dense>
            <v-list-item>
                <div class="d-flex align-center mx-4 mb-8" v-on:click="lancerParametre">
                    <v-icon class="ml-1 mr-2" size="35">mdi-cog</v-icon>
                    <v-list-item-title class="font-weight-bold">
                        Paramètres
                    </v-list-item-title>
                </div>
                <div class="d-flex align-center mx-4 my-3" v-on:click="deconnexion">
                    <v-icon class="ml-1 mr-2" size="35">mdi-logout</v-icon>
                    <v-list-item-title class="font-weight-bold">
                        Déconnexion
                    </v-list-item-title>
                </div>
            </v-list-item>
        </v-list>
    </v-navigation-drawer>
    <PopupcodeCPS ref="popupCodeCPS"
                  :visible="showPopupCPS"
                  :onClose="fermerPopup"
                  :onValidate="validerCode" />
    <!-- AffichageErreurVue : NON enregistre ici (balise morte historique) -> rendu par
         TransCAM.vue, present sur toutes les pages /transcam*. Tag retire pour eviter
         le warning Vue "failed to resolve component". -->
</template>


<script>
    import { defineComponent } from 'vue';
    import RequestManager from '../script/request.js';
    import PopupcodeCPS from "./TransCAM/PopupcodeCPS.vue";
    import { demanderPinSiRequis } from '@/script/pinCps';

    export default defineComponent({
        components: {
            PopupcodeCPS,
        },
        data() {
            return {
                drawer: !RequestManager.estMobile,
                items: [
                    { title: 'Nouvelle Feuille', icon: 'mdi-plus', method: 'lancerFSE' },
                    { title: 'Patient', icon: 'mdi-account', method:'lancerPatient' }, 
                    { title: 'Feuilles de soins', icon: 'mdi-file-document', method: '' },    
                    { title: 'Envois', icon: 'mdi-inbox-arrow-up', method: 'lancerLots' },            
                    { title: 'Retours', icon: 'mdi-inbox-arrow-down', method: '' },         
                    { title: 'Erreurs', icon: 'mdi-alert-circle', method: 'lancerPageErreurs' }               
                ],
                showPopupCPS : false,
            };
        },


        computed: {
            connexionValeur() {
                return this.$store.getters["ConnexionStore/getConnexionValeur"];
            },
            estMobile() {
                return RequestManager.estMobile;
            }
        },

        methods: {
            initTransCAM() {
                //alert("On init TransCAM");
                this.$store.dispatch("ConnexionStore/setAppliLance", { name: "TransCAM" });
                this.$store.dispatch("ConnexionStore/setAppliLaunched", true)

                // On n'affiche plus la popup de code CPS automatiquement a l'entree :
                // - en connexion identifiant/mot de passe, elle n'a pas lieu d'etre ;
                // - en connexion CPS, la carte vient d'etre lue et deverrouillee ;
                //   le PIN n'est jamais conserve et n'est redemande qu'au besoin.
                // De plus la relecture declenchee par la popup ecrasait la carte CPS
                // (perte du nom praticien). L'utilisateur peut toujours relire via "Lire CPS".
            },
            afficherPopUpCPS() {
                //alert("On affiche la popUp")
                this.$refs.popupCodeCPS.code = "";
                this.showPopupCPS = true;
            },
            fermerPopup() {
                this.$refs.popupCodeCPS.code = "";
                this.showPopupCPS = false;
            },
            validerCode() {
                alert("On valide !!!")
                //console.log("validerCode refs = ", this.$refs);
                //let code = this.$refs.popupCodeCPS.code;
                //alert("code = " + code);
                //alert("Avant LireCartePS")
                //RequestManager.EnvoyerMessageWebView({ action: "LireCartePS", parameters: [code] });
                //alert("Après LireCartePS")
            },
            lancerPageErreurs() {
                this.$router.push({ name: "ErreursTransCAM" });
            },
            reload() {
                var timestamp = new Date().getTime();

                // Ajoutez ce paramètre à l'URL actuelle
                var url = window.location.href + "?timestamp=" + timestamp;

                // Rechargez la page avec le nouveau paramètre
                window.location.href = url;
            },
            showMenu() {
                var containerLinks = document.getElementById("container-links");
                var containerNavBar = document.getElementById("container-navBar");

                var bool = containerLinks.classList.toggle("show");
                if (bool) {
                    containerLinks.style.top = 99 + "px";
                }
                else {
                    containerLinks.style.top = 0 + "px";
                }
            },
            deconnexion() {
                this.$store.dispatch('ConnexionStore/deconnexion');
            },
            lancerFisimedClients() {
                if (this.connexionValeur) {
                    this.$store.dispatch("ConnexionStore/setAppliLance", { name: "Fisimed" });
                    this.$store.dispatch("ConnexionStore/setAppliLaunched", true)
                    this.$router.push({ name: "Fisimed" });
                }
            },

            lancerAltyseClients() {
                if (this.connexionValeur) {
                    this.$store.dispatch("ConnexionStore/setAppliLance", { name: "Altyse" });
                    this.$store.dispatch("ConnexionStore/setAppliLaunched", true)
                    this.$router.push({ name: "Altyse" });
                }
            },
            lancerFlic32() {
                if (this.connexionValeur) {
                    this.$store.dispatch("ConnexionStore/setAppliLance", { name: "Flic32" });
                    this.$store.dispatch("ConnexionStore/setAppliLaunched", true)
                    this.$router.push({ name: "Flic32" })
                }
            },
            lancerTransCAM() {
                if (this.connexionValeur) {
                    this.$store.dispatch("TransCAM/setAppliLance", { name: "TransCAM" });
                    this.$store.dispatch("TransCAM/setAppliLaunched", true)
                    this.$router.push({ name: "TransCAM" })
                }
            },

            appliLance() {
                return this.$store.getters["ConnexionStore/getAppliLance"];
            },

            callItemMethod(methodName) {
                if (methodName && typeof this[methodName] === 'function') {
                    this[methodName]();
                } else {
                    console.warn(`Méthode "${methodName}" introuvable ou non définie.`);
                }
            },

            async lancerVitale() {
                let pin;
                try { pin = await demanderPinSiRequis(this.$store); }
                catch (e) { return; } // PIN annule -> on abandonne
                RequestManager.EnvoyerMessageWebView({ action: "LireCarteVitale", parameters: [pin] });
                this.$router.push('/transcam/LireCarteVitale');
            },

            lireCPS() {
                this.afficherPopUpCPS();
                //RequestManager.EnvoyerMessageWebView({ action: "LireCartePS", parameters: ["1234"] });
            },

            lancerFSE() {
                this.$router.push('/transcam/fse');
            },

            lancerNewFSE() {
                this.$router.push({ name: 'NewFSE' });
            },

            lancerPatient() {
                this.$router.push('/transcam/Patient');
            },

            lancerLots() {
                this.$router.push('/transcam/Lots');
            },

            lancerEnvois() {
                this.$router.push('/Envois');
            },

            lancerParametre() {
                this.$router.push('/transCam/parametre/');
            }
        },

        props: {

        },
        created() {
            this.initTransCAM();
        },
        mounted() {
            var containerLinks = document.getElementById("container-links");
            var containerNavBar = document.getElementById("container-navBar");

            //containerLinks.style.top = 0 +"px";
            console.log("$refs = ", this.$refs)
        },


    });
</script>
<style scoped>
    .v-navigation-drawer {
        border-right: 1px solid #ddd;
    }
    .v-list-item-icon {
        min-width: 24px;
    }
    .v-icon {
        color: #434343;
    }

    /* Bouton flottant de bascule du menu (mobile) : toujours au-dessus du drawer */
    .navbar-toggle-btn {
        position: fixed;
        top: 10px;
        left: 10px;
        z-index: 2500;
    }
    .navbar-toggle-btn .v-icon {
        color: #fff;
    }

</style>>
